import React, { useEffect, useState } from "react";
import { ref, set, get, onValue, query} from 'firebase/database';
import { database } from '../firebase_config/firebase';
import { UserAuth } from '../context/AuthContext';
import { useNavigate } from "react-router-dom";
import LoadingComponent from "../components/loading_backdrop";
import SideNav from "../components/side_nav";
import showToast from "../components/toast";
import { ToastContainer } from "react-toastify";
import { Box, Card, CardContent, Chip, Container, Fab, IconButton, Typography } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { Add, AddCircleOutlineOutlined, Visibility } from "@mui/icons-material";
import NewProjectDrawer from "../components/new-project-drawer";
import getProjectStatus from "../utils/get-project-status";


const Home = () =>{
  const { user } = UserAuth();
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [newProjectDrawer, setNewProjectDrawer] = useState(false);

  const handleCardClick = (uniqueId) =>{
    navigate(`/dashboard/${uniqueId}`)
  }

  const openNewProjectDrawer = () => {
    setNewProjectDrawer(true);
  };

  const closeNewProjectDrawer = () => {
    setNewProjectDrawer(false);
  };


  const handleProjectCreated = (newProject) => {
    setProjects((prevProjects) => [...prevProjects, newProject]);
  };

  useEffect(() => {
    let isMounted = true;
    const usersRef = ref(database, 'Users/' + user.uid + '/Projects');
  
    const get_projects = async () => {
      try {
        const snapshot = await get(query(usersRef));
  
        if (!snapshot.exists()) {
          if (isMounted) {
            setProjects([]);
            setIsLoading(false);
          }
          return;
        }
  
        const projectsArray = [];
  
        snapshot.forEach((childSnapshot) => {
          const childData = childSnapshot.val();
          const name = childData.name;
          const id = childData.id;
          const status = childData.status;
  
          projectsArray.push({
            name: name,
            id: id,
            status: status,
            timestamp: childData.timestamp
          });
        });
  
        if (isMounted) {
          setProjects(projectsArray);
          setIsLoading(false);
        }
  
      } catch (error) {
        if (isMounted) {
          showToast(error.message);
          setIsLoading(false);
        }
      }
    };
  
    get_projects();
  
    return () => {
      isMounted = false;
    };
  
  }, [user.uid]);
  
      
  return (
    <Box>
      <SideNav/>
      
      {isLoading && <LoadingComponent/>}
          

      {!isLoading && 
        <Fab
          style={{
            backgroundColor: "#008000",
            position: 'fixed',
            bottom: '16px',
            right: '16px',
            zIndex: 1000,
          }}
          aria-label="add"
          onClick={openNewProjectDrawer}
        >
          <Add sx={{ fontSize: 30, color: '#fff' }} />
        </Fab>
      }
        
      <Container>

        {!isLoading && projects.length === 0 && 

          <Box 
            sx={{
              mt: 13,
              border: '1px dashed #000000',
              height: '150px',
              borderRadius: '10px',
              padding: 4,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: 'grey.100'
            }}
          >
            <IconButton onClick={openNewProjectDrawer}>
                <AddCircleOutlineOutlined sx={{ fontSize: 60, color: 'grey.500' }} />
            </IconButton>
            <Typography sx={{ fontFamily: 'Roboto, sans-serif' }}>
                Start by Creating a New Project
            </Typography>
          </Box>
        }

      <Grid2 container sx={{ mt: 10 }} spacing={2}>
        {!isLoading &&  (
          projects.sort((a, b) => {
            return new Date(b.timestamp) - new Date(a.timestamp);
          }).map((project, index) => {
            
            const { label, color } = getProjectStatus(project.status);

            return (
              <Grid2 item xs={12} md={6} key={index}>
                <Card
                  onClick={() => handleCardClick(project.id)}
                  sx={{
                    borderRadius: '12px',
                    backgroundColor: 'grey.50',
                    border: '1px solid', 
                    borderColor: 'grey.300',
                    boxShadow: 'none',
                    transition: 'background-color 0.3s ease, border-color 0.3s ease, transform 0.3s ease',
                    '&:hover': {
                      backgroundColor: 'grey.100',
                      borderColor: 'primary.main',
                      transform: 'translateY(-2px)',
                      boxShadow: 'none',
                    },
                    cursor: 'pointer',
                  }}
                >
                  <CardContent
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      p: 3,
                      position: 'relative',
                    }}
                  >
                    <Box sx={{ flexGrow: 1 }}>
                      <Typography
                        variant="h6"
                        sx={{
                          fontFamily: '"Poppins", sans-serif',
                          color: '#333333',
                          fontWeight: 600,
                          mb: 1,
                        }}
                      >
                        {project.name}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                          fontFamily: '"Poppins", sans-serif',
                        }}
                      >
                        ID: {project.id}
                      </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 2 }}>
                      <Chip
                        label={label}
                        color={color}
                        size="small"
                        sx={{
                          fontWeight: 'bold',
                          borderRadius: '6px',
                        }}
                      />
                      <Visibility sx={{ color: '#081247', fontSize: '24px' }} />
                    </Box>
                  </CardContent>
                </Card>
              </Grid2>
            );
          })
        )}
      </Grid2>
        
      </Container>
      
      <NewProjectDrawer 
        open={newProjectDrawer} 
        onClose={closeNewProjectDrawer}
        onProjectCreated={handleProjectCreated}
      />

      <ToastContainer/>
    </Box>
  )
}

export default Home;